function cleanEmptyValues (obj) {
	for (const propName in obj) {
		if (obj[propName] === null || obj[propName] === undefined || obj[propName] === '') {
			delete obj[propName]
		}
	}
	return obj
}

function getSeverityByStatusCode (code) {
	const infoSeverityCodes = [404]

	if (code >= 500) {
		return 'error'
	}

	return infoSeverityCodes.includes(code) ? 'info' : 'warning'
}

const CANCEL_TOKEN_MAP = {
	EMPTY_TOKEN: (token, url) => `[RequestCancelled] Got an empty. Token: ${token}. Url: ${url}`,
	GET_TOKEN_FAIL: (message, url) => `[RequestCancelled] Failed to get token. Reason: ${message}. Url: ${url}`
}

export default function ({ $axios, $bugsnag, $firebase, store }) {
	$axios.onRequest(
		async (config) => {
			if (config.sharedAuthorization && !config.doubleTokens) {
				config.headers['X-Shared-Authorization'] = config.sharedAuthorization
			} else if (!config.skipAuth) {
				await $firebase.getUserIdToken(null, config.tokenForceUpdate)
					.then((token) => {
						if (token) {
							config.headers.Authorization = `Bearer ${token}`

							if (config.doubleTokens && config.sharedAuthorization) {
								config.headers['X-Shared-Authorization'] = config.sharedAuthorization
							}
						} else {
							config.cancelToken = new $axios.CancelToken(cancel => cancel(CANCEL_TOKEN_MAP.EMPTY_TOKEN(token, config.url)))
						}
					})
					.catch((error) => {
						config.cancelToken = new $axios.CancelToken(cancel => cancel(CANCEL_TOKEN_MAP.GET_TOKEN_FAIL(error.message, config.url)))
					})
			}

			if (config.serializeBody) {
				config.data = cleanEmptyValues(config.data)
			}

			return config
		},
		err => Promise.reject(err)
	)

	$axios.onError((error) => {
		const logout = (message) => {
			store.dispatch('auth/logout')
			// TODO: Show toast message here
		}

		if ($axios.isCancel(error)) {
			$bugsnag.notify(new Error(error.message), (event) => {
				event.severity = 'info'
			})

			return Promise.reject(error)
		} else if (error.response) {
			const requestConfig = {
				url: error.config.url,
				baseURL: error.config.baseURL,
				headers: error.config.headers,
				data: error.config.data
			}
			const response = {
				data: error.response.data,
				headers: error.response.headers,
				statusCode: parseInt(error.response.status),
				statusText: error.response.statusText
			}

			$bugsnag.notify(error, (event) => {
				event.addMetadata('request-metadata', { requestConfig, response })
				event.severity = getSeverityByStatusCode(response.statusCode)
				event.context = requestConfig.url
			})

			if (response.statusCode === 401) {
				logout('Error: Unauthorized')
			}

			return Promise.reject(error.response.data)
		} else {
			$bugsnag.notify(error, (event) => {
				if (error?.config) {
					const requestConfig = {
						url: error.config.url,
						baseURL: error.config.baseURL,
						headers: error.config.headers,
						data: error.config.data
					}

					event.addMetadata('request-metadata', { requestConfig })
					event.context = requestConfig.url
				}
			})

			return Promise.reject(error)
		}
	})
}
